@if (itemClassLabel || itemTypeName) {
  <div class="chips-root d-flex">
    @if (itemClassLabel) {
      <div class="d-flex flex-column align-items-center me-3">
        <small class="text-muted mt-1">Class</small>
        <mat-chip-set>
          <mat-chip class="custom-chip" aria-label="Item class {{ itemClassLabel }}">{{ itemClassLabel }}
          </mat-chip>
        </mat-chip-set>
      </div>
    }
    @if (itemTypeName) {
      <div class="d-flex flex-column align-items-center">
        <small class="text-muted mt-1">Type</small>
        <mat-chip-set>
          <mat-chip class="custom-chip" aria-label="Item type {{ itemTypeName }}">{{ itemTypeName }}</mat-chip>
        </mat-chip-set>
      </div>
    }
  </div>
}
